import { Dispatch } from 'react'

import { ClientScenario } from '@cash-web/protos/squareup/franklin/api/client_scenario.pb'
import { ResponseContext } from '@cash-web/protos/squareup/franklin/ResponseContextProto.pb'
import {
  CashResponse,
  CashResponseContext,
  ensureHeadersRequest,
  flowTokenRequest,
  rejectOnErrorResponse,
} from '@cash-web/shared-util-fetch'

import { FlowReducerAction, FlowState } from '../hooks/flowReducer'

const exclude =
  <T>(excluded: T[]) =>
  (thing: T) => {
    return !excluded.includes(thing)
  }
export const excludeResponseMiddleware = exclude([rejectOnErrorResponse])
export const excludeDeprecatedRequestMiddleware = exclude([ensureHeadersRequest, flowTokenRequest])
export type FlowResponse = {
  response_context?: ResponseContext
  status?: 'SUCCESS' | 'SUCCESS_WITH_VERIFICATION_DATA' | string
  token?: string
  client_scenario?: ClientScenario
}
export type FlowResponseMiddlewareData = {
  state: FlowState
  dispatch: Dispatch<FlowReducerAction>
  response: CashResponse<FlowResponse>
  context?: CashResponseContext
}
export type FlowStateDispatch = { state: FlowState; dispatch: Dispatch<FlowReducerAction> }
